<template>
  <div class="outer-box">
    <h3>Support AI</h3>
    <div class="inner-box support-ai-inner">
      <BotpressChat
        v-if="botpressBotId && botpressClientId && botVisible"
        :visible="botVisible"
        :bot-id="botpressBotId"
        :client-id="botpressClientId"
        :visitor-id="visitorId"
        bot-name="AI Support Assistant"
        :user-email="userEmail"
        :user-name="userName"
        :user-permissions="userPermissions"
        :current-url="currentUrl"
        source="support-portal"
        @update:visible="botVisible = $event"
      />
      <div v-if="botpressBotId && botpressClientId && !botVisible" class="reopen-chat">
        <p class="text-muted">Chat closed.</p>
        <button class="btn btn-primary" @click="botVisible = true">Open Support AI</button>
      </div>
      <div v-if="(!botpressBotId || !botpressClientId)" class="reopen-chat">
        <p class="text-muted">Support AI (Botpress) is not configured. Set VUE_APP_BOTPRESS_BOT_ID and VUE_APP_BOTPRESS_CLIENT_ID in your .env file.</p>
      </div>
    </div>
  </div>
</template>

<script>
import BotpressChat from "./support-ai/BotpressChat.vue";

export default {
  name: "SupportAI",
  components: {
    BotpressChat,
  },
  data() {
    return {
      botVisible: true,
    };
  },
  computed: {
    botpressBotId() {
      return "958137fd-6f13-4331-8405-c534c3045a73";
    },
    botpressClientId() {
      return "7148cc59-475d-45cc-8358-3d085d8e08e9";
    },
    visitorId() {
      const user = this.$store.state?.auth?.user;
      return user?.email || "";
    },
    userEmail() {
      return this.$store.state?.auth?.user?.email || "";
    },
    userName() {
      return this.$store.state?.auth?.user?.name || "";
    },
    userPermissions() {
      const user = this.$store.state?.auth?.user;
      return user?.permissions ? JSON.stringify(user.permissions) : "";
    },
    currentUrl() {
      return typeof window !== "undefined" ? window.location.href : "";
    },
  },
};
</script>

<style scoped>
.support-ai-inner {
  min-height: 200px;
}
.reopen-chat {
  padding: 2rem;
  text-align: center;
}
</style>
